// Monthly brand-to-creator chat message allowances. Dumb constants (no imports), safe to require anywhere.

// Unlike team seats there is no free baseline: chat access itself is sold, so a brand whose offers grant no
// allowance has none of its own and the send gate's access rules decide what it can do.
const DEFAULT_MONTHLY_CHAT_MESSAGES = 0;
const UNLIMITED_CHAT_MESSAGES = 'UNLIMITED';

// Subscription unlock enums that grant a monthly send allowance, and the total each one grants (not an
// increment). UNLIMITED_CHAT is the long-standing Communications enum and doubles as the unlimited grant.
// Adding a new total means adding it here and to BRAND_UNLOCK_FEATURES in subscription_modules.js: an
// unlock is a boolean, so a number nobody has registered can't be sold.
const CHAT_MESSAGE_UNLOCKS = {
  CHAT_MESSAGES_500_PER_MONTH: 500,
  UNLIMITED_CHAT: UNLIMITED_CHAT_MESSAGES
};

/*
  Messages a brand may send per calendar month, shared by client and server so both agree.
  `override` is BrandSettings.featureFlags.chatMessagesConfiguredPerMonth. Absent means "no override, use
  the subscription", and it wins in both directions when set, so a support-set cap can also lower a brand
  below what its package grants, all the way to zero (unlike team seats, zero is a meaningful allowance
  here: it shuts brand sends off entirely).

  Multiple grants resolve to the largest, not a sum: an offer carrying both a total and unlimited grants
  unlimited rather than an arbitrary combination.
*/
const resolveMonthlyChatMessages = ({ unlocks = [], override } = {}) => {
  if (override === UNLIMITED_CHAT_MESSAGES) return UNLIMITED_CHAT_MESSAGES;
  if (typeof override === 'number' && override >= 0) return override;

  const grants = unlocks.map(unlock => CHAT_MESSAGE_UNLOCKS[unlock]).filter(grant => grant !== undefined);
  if (!grants.length) return DEFAULT_MONTHLY_CHAT_MESSAGES;
  if (grants.includes(UNLIMITED_CHAT_MESSAGES)) return UNLIMITED_CHAT_MESSAGES;
  return Math.max(...grants);
};

module.exports = {
  DEFAULT_MONTHLY_CHAT_MESSAGES,
  UNLIMITED_CHAT_MESSAGES,
  CHAT_MESSAGE_UNLOCKS,
  CHAT_MESSAGE_UNLOCK_ENUMS: Object.keys(CHAT_MESSAGE_UNLOCKS),
  resolveMonthlyChatMessages
};
